import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { IDeleteApiResponse, IError, apiLimit } from "../../utils/api.types";

import {
  InvoiceSeqNumber,
  InvoiceFormInputs,
  InvoiceResponse,
  AInvoices,
  AInvoiceResponse,
  AInvoiceUpdatePayload,
  InvoiceFetch,
  InvoicePreviewResponse,
  InvoicePreviewPayload,
  InvoiceDispatch,
  IDispatchApiResponse,
  ITemplate,
  ShareInvoiceForm,
  IShareInvoiceApiResponse
} from "../../utils/invoice.types";

// Fetch Credit Note InvoiceSeqNumber async thunk.
export const fetchInvoiceSeqNumber = createAsyncThunk(
  'creditNote/fetchInvoiceSeqNumber',
  async (saleType: string): Promise<InvoiceSeqNumber> => {
      const response = await axios.get(`/api/v1/sales/credit-note/seq-number?saleType=${saleType}`);

      return response.data
  }
);

// Add Credit Note Invoice async Thunk.
 export const addInvoiceCreditNote = createAsyncThunk(
  'creditNote/addInvoiceCreditNote',
  async (invoicePayload: InvoiceFormInputs): Promise<InvoiceResponse> => {
    let path = null;
    if (invoicePayload.invoiceType) {
        path = getApiPath(invoicePayload.invoiceType);
    }
    const response = await axios.post(`/api/v1/sales/${path}/create`, invoicePayload);
    return response.data
  }
);

/**
 * Update Credit Note async Thunk.
 */
 export const updateInvoiceCreditNote = createAsyncThunk<
 AInvoiceResponse,
 AInvoiceUpdatePayload,
 {
     rejectValue: IError,
 }
>(
 'creditNote/updateInvoiceCreditNote',
 async ({ id, invoicePayload }: AInvoiceUpdatePayload, thunkApi) => {
     try {
        let path = null;
        if (invoicePayload.invoiceType) {
            path = getApiPath(invoicePayload.invoiceType);
        }
         const response = await axios.put(`/api/v1/sales/${path}/${id}`, invoicePayload);

         const { data } = response;

         if (response.status === 200) {
             return data;
         }

         return thunkApi.rejectWithValue(data.error);
     } catch (error: any) {
         return thunkApi.rejectWithValue(error.response.data);
     }
 }
);

//Dispatch Credit Note Invoice async Thunk.
export const dispatchInvoiceCreditNote = createAsyncThunk(
    'creditNote/dispatchInvoice',
    async ({invoiceId, params, dispatchPayload}: InvoiceDispatch): Promise<IDispatchApiResponse> => {
        let queryParam = (params)? `?${params}`: ''
        const response = await axios.post(`/api/v1/sales/credit-note/${invoiceId}/dispatch${queryParam}`, dispatchPayload);
  
        return response.data
    }
  );


/**
 * Fetch Credit Note Invoices async thunk.
*/
export const fetchCreditNotes = createAsyncThunk(
    'creditNote/fetchCreditNotes',
    async ({accountId, type, params} : InvoiceFetch): Promise<AInvoices> => {
        // let path = (type==='account-receivable')? `${accountId}/account-receivables` : `${accountId}/account-payables`
        let path = `${accountId}/credit-notes/`
        let queryParam = (params)? `&${params}`: ''
        const response = await axios.get(`/api/v1/sales/account/${path}?limit=${apiLimit.limit}${queryParam}`);
        return response.data;
    }
);


export const fetchInvoicesWithoutState = createAsyncThunk(
    'creditNote/fetchInvoicesWithoutState',
    async ({accountId, type, params} : InvoiceFetch): Promise<AInvoices> => {
        let path = (type==='account-receivable')? `${accountId}/account-receivables` : `${accountId}/account-payables`
        let queryParam = (params)? `&${params}`: ''
        const response = await axios.get(`/api/v1/sales/credit-note/account/${path}?limit=${apiLimit.limit}${queryParam}`);
        return response.data;
    }
);

export const selectedInvoiceID = createAction("invoice/selectedInvoiceID", (invoiceId) => {
    return {
        type: 'invoice/selectedInvoiceID',
        payload: invoiceId
    }
});


/**
 * Update Credit Note Invoices async Thunk.
 */
export const updateInvoice = createAsyncThunk<
    AInvoiceResponse,
    AInvoiceUpdatePayload,
    {
        rejectValue: IError,
    }
>(
    'invoice/updateInvoice',
    async ({ id, invoicePayload }: AInvoiceUpdatePayload, thunkApi) => {
        try {
            const response = await axios.put(`/api/v1/sales/credit-note/${id}`, invoicePayload);

            const { data } = response;

            if (response.status === 200) {
                return data;
            }

            return thunkApi.rejectWithValue(data.error);
        } catch (error: any) {
            return thunkApi.rejectWithValue(error.response.data);
        }
    }
);


/**
 * Fetch Credit Note Invoices async thunk.
*/
export const fetchInvoiceCreditNoteById = createAsyncThunk(
    'credit-note/fetchInvoiceCreditNoteById',
    async ({id, invoiceType}: any): Promise<AInvoices> => {
        let path = null;
        if (invoiceType) {
            path = getApiPath(invoiceType);
        }
        console.log("testing route path ===== ;;;;;;;;; ", path);
        const response = await axios.get(`/api/v1/sales/${path}/${id}`);
        return response.data;
    }
);

/**
 * Delete Credit Note Invoices async Thunk.
*/
export const deleteInvoice = createAsyncThunk(
    'invoice/deleteInvoice',
    async (id: string): Promise<IDeleteApiResponse> => {
        const response = await axios.delete(`/api/v1/invoice/${id}`);

        response.data['id'] = id;

        return response.data
    }
);

/**
 * Delete Invoices async Thunk.
 */
 export const manualPayment = createAsyncThunk(
    'invoice/manualPayment',
    async (payload: any): Promise<IDeleteApiResponse> => {
        const response = await axios.post('/api/v1/invoice/payments', payload);
        return response.data
    }
);

export const fetchInvoicePreview = createAsyncThunk<InvoicePreviewResponse,
InvoicePreviewPayload,
{
    rejectValue: IError,
}
 >(
    'invoice/preview',
    async ({invoiceId, templateId}: InvoicePreviewPayload, thunkApi) => {

        try {
            const response = await axios.get(`/api/v1/invoice/${invoiceId}/templates/${templateId}`);
            const { data } = response;
            if (response.status === 200) {
                return data;
            }
            return thunkApi.rejectWithValue(data.error);
        } catch (error: any) {
            return thunkApi.rejectWithValue(error.response.data);
        }
       
    }
);

/**
 * Fetch Credit Note Invoice Payment Receipts PDF async Thunk.
 */

export const fetchInvoicePaymentReceiptPreview = createAsyncThunk<InvoicePreviewResponse,
InvoicePreviewPayload,
{
    rejectValue: IError,
}
 >(
    'invoice-payment-receipt/preview',
    async ({invoiceId, templateId}: InvoicePreviewPayload, thunkApi) => {

        try {
            const response = await axios.get(`/api/v1/invoice/${invoiceId}/payment-receipt-templates/${templateId}`);
            const { data } = response;
            if (response.status === 200) {
                return data;
            }
            return thunkApi.rejectWithValue(data.error);
        } catch (error: any) {
            return thunkApi.rejectWithValue(error.response.data);
        }
       
    }
);


/**
 * Send Credit Note Invoice Payment Receipts async Thunk.
 */

export const shareInvoicePaymentReceipt = createAsyncThunk(
    'invoice/sendInvoceReceipt',
    async (data: ShareInvoiceForm): Promise<IShareInvoiceApiResponse> => {
        const response = await axios.post('/api/v1/invoice/share', data);
        return response.data;
    }
);


/**
 * Fetch Credit Note Invoice templates async thunk.
*/
export const fetchTemplates = createAsyncThunk(
    'invoice/fetchTemplates',
    async (): Promise<ITemplate[]> => {
        const response = await axios.get(`/api/v1/invoice/templates`);
        return response.data;
    }
);


const getApiPath = (invoiceType: string) => {
    if (invoiceType==='Debit Note') return "debit-note"
    if (invoiceType==='sale-debit-note') return "debit-note"
    if (invoiceType==='Credit Note') return "credit-note"
    if (invoiceType==='sale-delivery-note') return "delivery-note"
    if (invoiceType==='sale-invoice') return "invoice"
}